import {createStyles, Theme} from "@material-ui/core";

export const MagicContainerStyle = (theme: Theme) => createStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "16px 24px 24px",
    margin: "0 auto",
    boxSizing: "border-box",
    marginTop: 64,
    maxWidth: 600,
    [theme.breakpoints.down('xs')]: {
      width: "100%",
      boxShadow: "none",
      border: "none",
    },
  },
  button: {
    marginTop: 16
  },
});



// WEBPACK FOOTER //
// ./src/containers/magic/magic.style.ts